import { render, staticRenderFns } from "./ProtocoloBusca.vue?vue&type=template&id=42784e4c&scoped=true"
import script from "./ProtocoloBusca.vue?vue&type=script&lang=js"
export * from "./ProtocoloBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42784e4c",
  null
  
)

export default component.exports